/*
  Вкладка «Суд»: подать заявление и унести документы — §3.4.

  Заведена 21.09.2026 при разборе карточки на вкладки, в тот же день
  перестроена по указанию владельца: документы переехали сюда из отдельной
  вкладки, а полученный приказ - в свою («Приказ»). Причина в порядке работы:
  пакет собирают и тут же забирают файлы, чтобы подписать и отправить, - два
  действия одного захода, разнесённые по двум вкладкам.

  Полученный приказ этому заходу не принадлежит: между подачей и приказом
  проходят недели, и открывают карточку тогда за другим.

  🔴 Вкладка показывается только тому, у кого есть право вести дело
  (`manage_stages`). Оператору коммуникаций её не видно вовсе - не потому, что
  формы бы отказали (их сторожит сервер), а потому, что вкладка, за которой для
  человека нет ни одного доступного действия, обещает несуществующее.
*/

import AccountActions from './AccountActions.jsx'
import AccountDocuments from './AccountDocuments.jsx'
import AssemblyClosedNote from './AssemblyClosedNote.jsx'
import ProtocolScanAttachment from './ProtocolScanAttachment.jsx'

// Пустой список без кнопки сборки: прежний текст отсылал бы к «Сформировать пакет», которой нет.
const CLOSED_EMPTY = 'Когда документы по этому счёту будут готовы, они появятся здесь.'

export default function AccountCourtTab({
  card,
  sections,
  sectionsError,
  canEdit,
  assemble,
  onDone,
}) {
  return (
    <>
      {/* Сборка пакета и уведомления: право роли и ярус участия (строка 127). На «Под ключ»
          кнопок нет, их место занимает пояснение, а не пустота. */}
      {assemble.allowed ? (
        <AccountActions
          card={card}
          sections={sections}
          sectionsError={sectionsError}
          onDone={onDone}
        />
      ) : null}
      {assemble.closedByTier ? <AssemblyClosedNote /> : null}

      {/* Удаление доступно тем же, кто собирает пакет. Право сторожит сервер, а
          кнопка не показывается тем, у кого его нет: предлагать действие,
          которое заведомо откажут, значит обещать невозможное. */}
      <AccountDocuments
        accountId={card.account_id}
        version={card}
        onDeleted={assemble.allowed ? () => onDone('Документ удалён.') : undefined}
        empty={assemble.allowed ? undefined : CLOSED_EMPTY}
      />

      {/* Скан протокола - список всех собственников дома: сервер отдаёт его только
          с правом собирать пакет (23.10.2026), и без права блока нет вовсе. */}
      {canEdit ? <ProtocolScanAttachment accountId={card.account_id} /> : null}
    </>
  )
}
